module.exports = __webpack_public_path__ + "img/canbadge_rectangle_tate.922f6ba3.png";